import _styled from "styled-components";
export const StyledNavigationContainer = _styled.div.withConfig({
  displayName: "Headerstyled__StyledNavigationContainer",
  componentId: "sc-zv2hk-0"
})(() => ({
  "position": "relative",
  "zIndex": "100",
  "borderWidth": "var(--border-width-0)",
  "borderBottomWidth": "1px",
  "borderStyle": "solid",
  "borderColor": "var(--neutral100, #C8C8C8)",
  "& nav>div:first-child": {
    "borderRightWidth": "1px !important",
    "borderStyle": "solid !important",
    "borderColor": "var(--neutral100, #C8C8C8) !important",
    "paddingTop": "1rem !important",
    "paddingBottom": "1rem !important"
  },
  "& ul": {
    "marginBottom": "0px"
  }
}));